module.exports = __webpack_public_path__ + "static/bg_persistant-18a5ec8c21cfe1acb719865c6fabb673.jpg";